import React, { useState } from 'react'
import styled from 'styled-components';
import ObservarLicencia from "./ObservarLicencia";
import NoAprobarLicencia from "./NoAprobarLicencia";
import ActionGenericModal from "../../../../components/modal/ActionGenericModal";
import {aprobarSolicitudCondicionLicenciaAPI} from "../../../../consumers/backendApisUrls";
import ModalEnabled from "../../../../components/modalComponents/ModalEnabled";
import TerminarLicencia from "./TerminarLicencia";

export const DetalleLicenciasCondicionActions = ({ idCondicion: IdCondicion, item, refreshMainPage, toggleMainModal, formValues }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [modalEnabled, setModalEnabled] = useState({ isEnable: false, component: React.Fragment });

  const fechaInicioCondicion = formValues?.FechaInicioCondicion;
  const fechaFinCondicion = formValues?.FechaFinCondicion;

  return (
    <div className="modal-footer justify-content-end pr-4">
      <ModalEnabled modalEnabled={modalEnabled} setModalEnabled={setModalEnabled} refreshPage={refreshMainPage} />
      <FooterButtons>
        {formValues?.PuedeObservar ===true &&
          <button
            type="button"
            className="btn btn-primary generic-button-ficha-modal generic-button-hover-azul"
            disabled={isSubmitting}
            onClick={() => setModalEnabled({ isEnable: true, component: ObservarLicencia, data: { toggleMainModal, IdCondicion } })}
          >
            Observar
          </button>
        }
        {formValues?.PuedeRechazar ===true&&
            <button
              type="button"
              className="btn btn-primary generic-button-ficha-modal generic-button-hover-rojo"
              disabled={isSubmitting}
              onClick={() => setModalEnabled({ isEnable: true, component: NoAprobarLicencia, data: { toggleMainModal, IdCondicion } })}
            >
              No Aprobar
            </button>
        }
        {formValues?.PuedeAprobar ===true&&
            <buttons
                type="button"
                className="btn btn-primary generic-button-ficha-modal generic-button-hover-verde"
                disabled={isSubmitting}
                onClick={(e) => {
                    e.preventDefault();
                    setModalEnabled({ isEnable: true, component: ActionGenericModal, data: { externalCallback: toggleMainModal, title: "Aprobar", actionLabel: "aprobar",
                            api: aprobarSolicitudCondicionLicenciaAPI, name: item, payload: { IdCondicion: IdCondicion } } })

                }}
            >
                Aprobar
            </buttons>
        }

        {formValues?.PuedeTerminar === true &&
              <button
                  type="button"
                  className="btn btn-primary generic-button-ficha-modal generic-button-hover-rojo"
                  disabled={isSubmitting}
                  onClick={() => setModalEnabled({ isEnable: true, component: TerminarLicencia, data: { toggleMainModal, IdCondicion, refreshMainPage, fechaInicioCondicion, fechaFinCondicion} })}
            >
                  Terminar
              </button>
         }

      </FooterButtons>
    </div>
  )
};


const FooterButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;